export default __webpack_public_path__ + "static/media/wrongBeep.adfbaedb.wav";